import * as moment from "moment";
import { KeepAppointmentActions } from './keep-appointment.actions';

export interface KeepAppointmentState {
	eventStorageId: string,
	timestamp: moment,
	userSetHasVisualQuota: boolean
};

const initialState: KeepAppointmentState = {
	eventStorageId: localStorage.getItem("eventStorageId") ? JSON.parse(localStorage.getItem("eventStorageId")) : null,
	timestamp: localStorage.getItem("timestamp") ? JSON.parse(localStorage.getItem("timestamp")) : null,
	userSetHasVisualQuota: localStorage.getItem("userSetHasVisualQuota") ? JSON.parse(localStorage.getItem("userSetHasVisualQuota")) : null
}

export const keepAppointmentReducer = (state = initialState, action) => {
	switch (action.type) {
		case KeepAppointmentActions.SET_KEEP_APPOINTMENT:
			return Object.assign({}, state, {
				eventStorageId: action.payload.eventStorageId,
				timestamp: action.payload.timestamp,
				userSetHasVisualQuota: action.payload.userSetHasVisualQuota
			})

		default: {
			return state;
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/components/keep-appointment/keep-appointment.reducer.ts